var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgQuestionAbnormal(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 19,
    height: 19,
    rx: 9.5,
    stroke: "#825DFC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99958 10.4285V8.29256M9.99958 12.0118V12.0305M12.6995 13.8095H7.29961C6.56201 13.8095 5.93954 13.322 5.7437 12.6551C5.6601 12.3703 5.76282 12.0738 5.91994 11.8213L8.61991 6.95282C9.25249 5.9363 10.7467 5.9363 11.3793 6.95282L14.0792 11.8213C14.2363 12.0738 14.3391 12.3703 14.2555 12.6551C14.0596 13.322 13.4372 13.8095 12.6995 13.8095Z",
    stroke: "#825DFC",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuestionAbnormal);
export default __webpack_public_path__ + "static/media/question-abnormal.fa47396adf8a6fd2e555f7093ea490ea.svg";
export { ForwardRef as ReactComponent };